import { RibbonRequest } from './RibbonRequest';
import { CmsRibbon } from '../../components/cms/CmsRibbon';
import { Theme } from '../../config/theme';
import { CardDataSource } from './CardDataSource';
import { CardSizeInfo } from './CardSizeInfo';
import { LLDataSource } from './LLDataSource';
import { Backend } from '../../api/Backend';
import { ICustomCmsRibbon, IRibbon2Asset } from '../../api/models/AndromeTV.types';
import { ChannelModel } from '../../api/EpgApi.types';

const _constants = {
  firstLoadAmount: 6,
  loadAmount: 3,
};

export class RibbonDataSource extends LLDataSource {
  private ribbon: ICustomCmsRibbon;
  private channels: ChannelModel[];
  private cmsProperties: string[];
  private sizeInfo: CardSizeInfo;
  private title: string | undefined;
  private ribbonRequest: RibbonRequest | undefined;
  private message: string | undefined;

  constructor(backend: Backend, ribbon: ICustomCmsRibbon, pageProperties: string[], channels: ChannelModel[]) {
    super(backend, _constants.firstLoadAmount, _constants.loadAmount);
    this.ribbon = ribbon;
    this.channels = channels;
    this.cmsProperties = this.combineProperties(ribbon.properties, pageProperties);
    this.cmsProperties.concat(pageProperties);
    this.sizeInfo = new CardSizeInfo();
    this.title = ribbon.title;
    if (this.title) {
      this.titleHeight = Theme.Fonts.Ribbon.Title.lineHeight;
    }
    this.message = ribbon.message;
  }

  /**
   * Load the first page of the ribbon
   */
  override load(): Promise<RibbonDataSource> {
    const fetchPagePromise = this._fetchPage(this.pageIdx);
    return fetchPagePromise.then(() => {
      this.pageIdx += 1;
      return this;
    });
  }

  _fetchPage(pageIdx: number): Promise<RibbonDataSource> {
    return new Promise(resolve => {
      if (!this.hasNextPage) {
        resolve(this);
        return;
      }
      // console.log('RibbonDataSource');
      if (!this.ribbonRequest) {
        this.ribbonRequest = new RibbonRequest(this.backend, this.ribbon, this.channels);
      }
      this.ribbonRequest.updateForProperties(this.cmsProperties);
      this.ribbonRequest.pageIdx = pageIdx;
      this.ribbonRequest.load().then(data => {
        // console.log('[RibbonDataSource] load succeeded', data);
        if (data) {
          this.sizeInfo.updateWithContainer(data, this.cmsProperties, this.ribbon);
          if (data.items) {
            this.items = this.items.concat(
              data.items.map(
                (card: IRibbon2Asset) =>
                  new CardDataSource(this.backend, card, this.sizeInfo, this.cmsProperties, this.channels)
              )
            );
          }
          this.hasNextPage = data.nextPage;
          // console.log(this.cards);
        }
        resolve(this);
      });
    });
  }

  /**
   * Check if a ribbon is empty
   */
  override isEmpty(): boolean {
    return super.isEmpty() && !this.message;
  }

  totalHeight() {
    return this.titleHeight + this.sizeInfo.height;
  }

  override componentDescription(): { focusable: boolean; type: typeof CmsRibbon; data: unknown; h: number } {
    return {
      focusable: true,
      type: CmsRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
